<script setup>
import { ref, onMounted, computed } from 'vue';
import { useCommonStore } from '@/stores/common';
import { useRouter } from 'vue-router';
import Dialog from 'primevue/dialog';

const store = useCommonStore();
const router = useRouter();

const imgURL = ref(store.cloudfrontImgURL);
const iconsURL = ref(store.cloudfrontIconURL);
const pdfURL = ref(store.cloudfrontPdfURL);
const ethicsLink = ref(pdfURL.value+'ethics.pdf');
const complaintsLink = ref(pdfURL.value+'complaints.pdf');
const privacyLink = ref(pdfURL.value+'privacycookiespolicy.pdf');
const termsLink = ref(pdfURL.value+'termsofbusiness.pdf');
const feesLink = ref(pdfURL.value+'feeschedule.pdf');
const showSearchBox = ref(false);
const activeMenu = ref();
const siteSearchTerms = ref('');
const showScrolledNav = ref(false);
const showDesktopNav = ref(true);
const showTabletNav = ref(false);
const showMobileNav = ref(false);
const showMobileMenu = ref(false);
const clientPortalURL = ref(store.rdLoginURL());
const mobileMenuHeroSectionBackground = computed(() => `url('${imgURL.value}mobile-menu-background.png')`); 
const menuSelectedHomepage = computed(() => {
    if(activeMenu.value === '/homepage') {
        return 'menu-link-active'
    } else {
        return 'menu-link-not-active'
    } 
});
const menuSelectedWhat = computed(() => {
    if(activeMenu.value === '/whatwedo') {
        return 'menu-link-active'
    } else {
        return 'menu-link-not-active'
    }
});
const menuSelectedWho = computed(() => {
    if(activeMenu.value === '/whowehelp') {
        return 'menu-link-active'
    } else {
        return 'menu-link-not-active'
    }
});
const menuSelectedInsights = computed(() => {
    if(activeMenu.value === '/insights' || activeMenu.value === '/insightsarticle') {
        return 'menu-link-active'
    } else {
        return 'menu-link-not-active'
    }
});
const menuSelectedCalculator = computed(() => {
  if(activeMenu.value === '/retirement-calculator') {
    return 'menu-link-active'
  } else {
    return 'menu-link-not-active'
  }
});
const menuSelectedEmployers = computed(() => {
    if(activeMenu.value === '/employers') {
        return 'menu-link-active'
    } else {
        return 'menu-link-not-active'
    }
});

async function searchSalesSite() {
    activeMenu.value = '/searchresults';
    if(showSearchBox) {
        showSearchBox.value = false; 
    }
    if(window.location.pathname === '/searchresults') {
        await router.push('/searchresults?q='+siteSearchTerms.value); 
        location.reload();
    }
    router.push('/searchresults?q='+siteSearchTerms.value); 
    siteSearchTerms.value = '';
}

function onScroll() {
    if(showDesktopNav.value) {
        const elm = document.getElementById('clarity-menu-nav');
        var pos = elm.getBoundingClientRect().top;
        if(pos === 0) {
            showScrolledNav.value = true;
        } else {
            showScrolledNav.value = false;
        }
    } 
}

function contactByPhone() {
    window.open('tel:+448003687511');
}

function viewportChange() {
    const viewportWidth = window.innerWidth;
    if(viewportWidth >= 1920) {
        showDesktopNav.value = true;
        showTabletNav.value = false;
        showMobileNav.value = false;
    } else if(viewportWidth < 1920 && viewportWidth >= 1366) {
        showDesktopNav.value = true;
        showTabletNav.value = false;
        showMobileNav.value = false;
    } else if(viewportWidth < 1366 && viewportWidth >= 768) {
        showDesktopNav.value = false;
        showTabletNav.value = true;
        showMobileNav.value = false;
    } else if(viewportWidth < 768 ) {
        showDesktopNav.value = false;
        showTabletNav.value = false;
        showMobileNav.value = true;
    }
}

onMounted(() => {
    viewportChange();
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", viewportChange)

    const pg = window.location.pathname;
    if(pg === '/') {
        activeMenu.value = '/homepage';
    } else {
        activeMenu.value = pg;
    }
});


</script>

<template>
        <div v-if="!showMobileNav" id="clarity-logo-nav" class="flex justify-between">
            <div class="flex items-center justify-center">
                <img :src="imgURL+'clarity-logo-blue.png'" alt="clarity Logo">
            </div>
            <div class="flex items-center justify-center">
                <input id="site-search-text" name="site-search-text" @keyup.enter="searchSalesSite" v-model="siteSearchTerms" class="clarity-menu-site-search" placeholder="Search website...">
                <img class="icon-img" @click="searchSalesSite" :src="iconsURL+'search-icon-grey.png'" style="vertical-align:middle;cursor:pointer;" alt="Search">
                <span class="clarity-grey">|</span>
                <p v-tooltip.bottom="{value:'+44 800 368 7511',pt:{arrow:{style:{borderBottomColor:'var(--clarity-dark-orange)'}},text:'contact-tooltip-bg-color'}}" @click="contactByPhone" class="contact-us-text flex"><img class="icon-img mt-[4px]" :src="iconsURL+'phone-icon-orange.png'" alt="Phone" style="vertical-align:middle;cursor:pointer;"> Contact Us</p>
            </div>
        </div>
        <div v-if="showTabletNav" id="clarity-logo-nav-tablet" class="flex justify-end flex-wrap clarity-padding-bottom-2xs">
            <img :src="iconsURL+'account-icon.svg'" class="account-icon" alt="Account Icon"><a :href="clientPortalURL" class="login-register-link">Login / Register</a>
        </div>
        <div v-if="!showMobileNav" id="clarity-menu-nav" class="flex justify-between flex-wrap">
            <div v-if="showScrolledNav" class="flex items-center justify-center">
                <img :src="imgURL+'clarity-logo-C-blue.png'" alt="clarity Logo">
            </div>
            <div class="flex items-center justify-center" :class="menuSelectedHomepage">   
                <a href="/homepage"><h4><span style="vertical-align:text-bottom;" class="material-icons">home</span> Home</h4></a>
            </div>
            <div class="flex items-center justify-center" :class="menuSelectedWhat">
                <a href="/whatwedo"><h4 >WHAT WE DO</h4></a>
            </div>
            <div class="flex items-center justify-center" :class="menuSelectedWho">
                <a href="/whowehelp"><h4>WHO WE HELP</h4></a>
            </div>
            <div class="flex items-center justify-center" :class="menuSelectedInsights">
                <a href="/insights"><h4 >INSIGHTS</h4></a>
            </div>
            <div class="flex items-center justify-center" :class="menuSelectedCalculator">
              <a href="/retirement-calculator">
                <h4 class="flex items-center">
                  <img
                      :src="iconsURL + (menuSelectedCalculator === 'menu-link-active' ? 'calculator-blue-icon.svg' : 'calculator-icon.svg')"
                      class="mb-1 mr-1 icon-img"
                      alt="calculator"
                  >
                  CALCULATOR
                </h4>
              </a>
            </div>
            <div class="flex items-center justify-center" :class="menuSelectedEmployers">
                <a href="/employers"><h4 class="clarity-grey" >EMPLOYERS</h4></a>
            </div>
            <div v-if="showScrolledNav" class="flex items-center justify-center">
                <img class="icon-img" @click="showSearchBox = true" :src="iconsURL+'search-icon-grey.png'" alt="Search" style="vertical-align:middle;cursor:pointer;"> <span class="clarity-grey">|</span> <img v-tooltip.bottom="{value:'+44 800 368 7511',pt:{arrow:{style:{borderBottomColor:'var(--clarity-dark-orange)'}},text:'contact-tooltip-bg-color'}}" @click="contactByPhone" :src="iconsURL+'phone-icon-orange.png'" alt="Phone" class="icon-img" style="vertical-align:middle;cursor:pointer;"> <span class="clarity-grey">|</span> <a :href="clientPortalURL"><img class="icon-img" :src="iconsURL+'account-icon.svg'" style="vertical-align:middle;cursor:pointer;" alt="Account Icon"></a>
            </div>
            <div v-else class="flex items-center justify-center">
                <img v-if="showDesktopNav" :src="iconsURL+'account-icon.svg'" class="account-icon" alt="Account Icon"><a v-if="showDesktopNav" :href="clientPortalURL" class="login-register-link">Login / Register</a>
            </div>
        </div>
        <div v-if="showMobileNav" id="clarity-mobile-nav" class="flex items-center justify-between flex-wrap">
            <div>
                <img :src="imgURL+'clarity-logo-blue.png'" alt="clarity Logo" class="mobile-logo">
            </div>
            <div class="flex items-center"> 
                <span @click="showSearchBox = true" class="material-icons scroll-nav-search-icon" style="vertical-align:middle;cursor:pointer;">search</span> | <a :href="clientPortalURL"><img class="icon-img" :src="iconsURL+'account-icon.svg'" alt="Account"></a> | <img @click="showMobileMenu = true" :src="iconsURL+'menu-icon.png'" alt="Menu Icon" class="menu-icon icon-img">
            </div>
        </div>
        <Dialog v-model:visible="showMobileMenu" modal position="top" :style="{width: '100rem',margin: '0px',border:'none'}">
            <template #container="{ closeCallback }">
                <ScrollPanel style="width: 100%; height: 80vh">
                    <div class="mobile-menu" :style="{ backgroundImage: mobileMenuHeroSectionBackground }">
                        <div id="mobile-menu-header" class="flex items-center justify-between flex-wrap">
                            <div>
                                <img :src="imgURL+'clarity-logo-white.png'" alt="clarity Logo" class="mobile-logo">
                            </div>
                            <div class="flex items-center"> 
                                <img @click="showSearchBox = true" class="scroll-nav-search-icon icon-img" :src="iconsURL+'search-icon-white.svg'" alt="Search" style="vertical-align:middle;cursor:pointer;"> <span class="clarity-white">|</span> <a :href="clientPortalURL"><img :src="iconsURL+'account-icon-white.svg'" alt="Account" style="vertical-align:middle;cursor:pointer;"></a> <span class="clarity-white">|</span> <img @click="contactByPhone" :src="iconsURL+'phone-icon.png'" alt="Phone" style="vertical-align:middle;cursor:pointer;"> <span class="clarity-white">|</span> <img @click="showMobileMenu = false" :src="iconsURL+'close-icon-white.png'" alt="Menu Icon" class="close-menu-icon" style="vertical-align:middle;cursor:pointer;">
                            </div>
                        </div>
                        <div id="mobile-menu-page-links">
                            <div class="mobile-menu-page-link flex">
                                <img class="mr-[3px] mt-[1px]" style="width: 24px;height: 24px;" :src="iconsURL+'home-icon-white.svg'" alt="Home"></img>
                                <a href="/homepage"><h4 class="clarity-h4-white">HOME</h4></a>
                            </div>
                            <div class="mobile-menu-page-link">
                                <a href="/whatwedo"><h4 class="clarity-h4-white">WHAT WE DO</h4></a>
                            </div>
                            <div class="mobile-menu-page-link">
                                <a href="/whowehelp"><h4 class="clarity-h4-white">WHO WE HELP</h4></a>
                            </div>
                            <div class="mobile-menu-page-link">
                                <a href="/insights"><h4 class="clarity-h4-white">INSIGHTS</h4></a>
                            </div>
                            <div class="mobile-menu-page-link">
                              <a href="/retirement-calculator"><h4 class="clarity-h4-white">CALCULATOR</h4></a>
                            </div>
                            <div class="mobile-menu-page-link">
                                <a href="/employers"><h4 class="clarity-h4-white">EMPLOYERS</h4></a>
                            </div>
                            <div class="mobile-menu-footer-link">
                                <a :href="ethicsLink" target="_blank"><p class="clarity-small-white-text">Ethics</p></a>
                            </div>
                            <div class="mobile-menu-footer-link">
                                <a :href="complaintsLink" target="_blank"><p class="clarity-small-white-text">Complaints</p></a>
                            </div>
                            <div class="mobile-menu-footer-link">
                                <a href="https://www.fca.org.uk/scamsmart" target="_blank"><p class="clarity-small-white-text">ScamSmart</p></a>
                            </div>
                            <div class="mobile-menu-footer-link">
                                <a href="/privacy-policy"><p class="clarity-small-white-text">Privacy & Cookies</p></a>
                            </div>
                            <div class="mobile-menu-footer-link">
                                <a :href="termsLink" target="_blank"><p class="clarity-small-white-text">Terms of Business</p></a>
                            </div>
                            <div class="mobile-menu-footer-link">
                                <a :href="feesLink" target="_blank"><p class="clarity-small-white-text">Fees</p></a>
                            </div>
                        </div>
                        <div id="mobile-menu-page-contact">
                            <p class="clarity-extra-small-text-white"><b>Contact us:</b> 1 Crown Square, Woking - Surrey, GU21 6HR - United Kingdom | +44 800 368 7511 | enquiries@clarityglobal.com | © 2003 - 2024 clarity Ltd. clarity is authorised and regulated by the Financial Conduct Authority. VAT No 164 1741 18. Reg No in England and Wales: 3466459.</p>
                            <div class="flex mt-3">
                                <a href="https://www.youtube.com/@clarityltd" target="_blank"><img class="clarity-margin-right-2xs" :src="imgURL+'social-media/youtube-icon-white-active.png'" alt="YouTube Logo"></a>
                                <a href="https://www.instagram.com/clarity_global/" target="_blank"><img class="clarity-margin-right-2xs" :src="imgURL+'social-media/instagram-icon-white-active.png'" alt="Instagram Logo"></a>
                                <a href="https://www.linkedin.com/company/clarityltd" target="_blank"><img class="clarity-margin-right-2xs" :src="imgURL+'social-media/linkedin-icon-white-active.png'" alt="Linkedin Logo"></a>
                                <a href="https://www.facebook.com/claritygloballtd" target="_blank"><img :src="imgURL+'social-media/facebook-icon-white-active.svg'" alt="Facebook Logo"></a>
                            </div>
                        </div>
                    </div>
                </ScrollPanel>    
            </template>    
        </Dialog>

        <Dialog v-model:visible="showSearchBox" modal :closable="false" :style="{ width: '30rem',margin:'20px'}">
            <template #header>
                <h2 class="clarity-h2-blue">Search Website</h2>
            </template>
            <div>
                <input @keyup.enter="searchSalesSite" v-model="siteSearchTerms" class="clarity-dialog-menu-site-search" placeholder="Search website...">
            </div>
            <template #footer>
                <button class="clarity-button-grey search-box-buttons" @click="searchSalesSite">Search</button>
                <button class="clarity-button-orange search-box-buttons" @click="showSearchBox = false">Close</button>
            </template>
        </Dialog>
        
</template>

<style lang="css" scoped>
    #clarity-mobile-nav {
        width: 100%;
        height: 90px;
        border-bottom: solid 1px var(--clarity-light-grey);
        background: var(--clarity-pure-white) 0% 0% no-repeat padding-box;
        padding: 20px;
    }
    #mobile-menu-header {
        padding: 20px;
    }
    /* #mobile-menu-page-links {} */
    #mobile-menu-page-contact {
        padding: 20px;
    }
    .mobile-menu-footer-link {
        width: 80%;
        padding: 10px 0px 10px 20px;
        margin-bottom: 10px;
        border-top: 1px solid var(--clarity-light-blue);
        border-bottom: 1px solid var(--clarity-light-blue);
        border-right: 1px solid var(--clarity-light-blue);
        border-radius: 0px 38px 38px 0px;
    }
    .mobile-menu-footer-link p {
        margin: 0px;
    }
    .mobile-menu-page-link {
        width: 90%;
        padding: 16px 0px 10px 20px;
        margin-bottom: 20px;
        border-top: 1px solid var(--clarity-light-blue);
        border-bottom: 1px solid var(--clarity-light-blue);
        border-right: 1px solid var(--clarity-light-blue);
        border-radius: 0px 38px 38px 0px;
    }
    .mobile-menu-page-link img {
        vertical-align: text-bottom;
    }
    .mobile-logo {
        height: 50px;
        width: auto;
    }
    #clarity-logo-nav {
        width: 100%;
        min-height: 111px;
        border-bottom: solid 1px var(--clarity-light-grey);
        background: var(--clarity-pure-white) 0% 0% no-repeat padding-box;
        padding-left: calc(15%);
        padding-right: calc(15%);
    }
    #clarity-menu-nav {
        z-index: 1000;
        position: sticky;
        top: 0;
        overflow: hidden;
        width: 100%;
        height: 60px;
        border-bottom: solid 1px var(--clarity-light-grey);
        box-shadow: 0px 5px 20px #0000000D;
        background: var(--clarity-pure-white) 0% 0% no-repeat padding-box;
        padding-left: calc(15%);
        padding-right: calc(15%);
    }
    #clarity-menu-nav h4 {
        padding-top: 8px;
    }
    .clarity-menu-site-search {
        width: 300px;
        margin-right: 10px;
        font-size: 16px;
        text-align: right;
        outline: none;
        border: none;
        border-bottom: 1px solid var(--clarity-grey);
    }
    .clarity-dialog-menu-site-search {
        width: 100%;
        height: 40px;
        padding: 15px 20px;
        font-size: 16px;
        font-family: var(--clarity-font-family-arial);
        background: var(--clarity-pure-white) 0% 0% no-repeat padding-box;
        border: 1px solid var(--clarity-light-grey);
        border-radius: 27px;
        opacity: 1;
    }
    .login-register-link {
        font: normal normal normal 16px/24px Open Sans;
        color: var(--clarity-blue);
    }
    .account-icon {
        width: 24px;
        height: 24px;
        margin-right: 5px;
    }
    .scroll-nav-search-icon {
        margin-left: 5px;
    }
    .menu-link-active {
        border-bottom: var(--clarity-blue) solid 2px;
    }
    .menu-link-active h4 {
        margin: 0px;
        letter-spacing: var(--clarity-character-spacing--0-18);
        color: var(--clarity-blue);
        font: normal normal normal 18px/28px Josefin Sans;
        text-transform: uppercase;
        opacity: 1;
    }
    .menu-link-not-active h4 {
        margin: 0px;
        letter-spacing: var(--clarity-character-spacing--0-18);
        color: var(--clarity-dark-grey);
        font: normal normal normal 18px/28px Josefin Sans;
        text-transform: uppercase;
        opacity: 1;
    }
    .contact-us-text {
        font: normal normal normal 18px/28px Open Sans;
        color: var(--clarity-orange);
        cursor:pointer;
    }
    .contact-us-text:hover {
        color: var(--clarity-dark-orange);
    }
    .search-box-buttons {
        height: 54px;
        width: 100px;
    }
    .menu-icon {
        cursor: pointer;
    }
    .close-menu-icon {
        width: 30px;
        height: 30px;
        cursor: pointer;
    }
    .mobile-menu {
        width: 100%;
        background-size: cover;
    }
    #clarity-logo-nav-tablet {
        padding-left: calc(15%);
        padding-right: calc(15%);
    }   
    .icon-img {
        width: 24px;
        height: 24px;
    }
    /* TABLET */
    @media only screen and (max-width: 1365px) {
        #clarity-logo-nav {
            z-index: 1000;
            min-height: 85px;
            position: sticky;
            top: 0;
            background-color: var(--clarity-pure-white);
        }
        #clarity-logo-nav-tablet {
            z-index: 1000;
            position: sticky;
            top: 85px;
            background-color: var(--clarity-pure-white);
        }
        #clarity-menu-nav {
            top: 125px;
        }
        #clarity-logo-nav, #clarity-menu-nav, #clarity-logo-nav-tablet {
            padding-left: calc(9%);
            padding-right: calc(9%);
        }
        #clarity-logo-nav-tablet {
            border-bottom: solid 1px var(--clarity-light-grey);
        }
        #clarity-logo-nav {
            border-bottom: none;
        }
    } 
    /* MOBILE */
    @media only screen and (max-width: 767px) {
        #clarity-logo-nav {
            height: 100px;
            border-bottom: none;
            background: var(--clarity-pure-white) 0% 0% no-repeat padding-box;
            padding-left: 20px;
            padding-right: 20px;
        }
        #clarity-logo-nav-tablet {
            width: 100%;
            padding-bottom: 10px;
            padding-left: 20px;
            padding-right: 20px;
            
        }
        #clarity-menu-nav {
            z-index: 1000;
            position: sticky;
            top: 0;
            overflow: hidden;
            width: 100%;
            height: 60px;
            border-bottom: solid 1px var(--clarity-light-grey);
            box-shadow: 0px 5px 20px #0000000D;
            background: var(--clarity-pure-white) 0% 0% no-repeat padding-box;
            padding-left: 20px;
            padding-right: 20px;
        }
        .account-icon {
            vertical-align: bottom;
        }
        .clarity-menu-site-search {
            width: 290px;
        }
    }
</style>